import { enUS, es, ptBR } from "date-fns/locale";
import type { Locale } from "date-fns";
import type { Language } from "@/lib/i18n";

const intlLocales: Record<Language, "pt-BR" | "en-US" | "es-ES"> = {
  pt: "pt-BR",
  en: "en-US",
  es: "es-ES",
};

const dateFnsLocales: Record<Language, Locale> = {
  pt: ptBR,
  en: enUS,
  es,
};

export function intlLocaleFor(language: Language): "pt-BR" | "en-US" | "es-ES" {
  return intlLocales[language];
}

export function dateFnsLocaleFor(language: Language): Locale {
  return dateFnsLocales[language];
}
